import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./ProtectedRoute";
import { ConfirmProvider } from "./Components/ui/Confirm";
import Login from "./Components/auth/Login";

const Dashboard = lazy(() => import("./Components/Widgets/Dashboard"));
const OrderHistory = lazy(() => import("./Components/pages/order/OrderHistory"));
const OrderDetail = lazy(() => import("./Components/pages/order/OrderDetail"));
const Payments = lazy(() => import("./Components/pages/payments/Payments"));
const UserData = lazy(() => import("./Components/pages/user/UserData"));
const CustomerDetail = lazy(() => import("./Components/pages/user/CustomerDetail"));
const Product = lazy(() => import("./Components/pages/product/Product"));
const AddProduct = lazy(() => import("./Components/partial/product/AddProduct"));
const UpdateProduct = lazy(() => import("./Components/partial/product/UpdateProduct"));
const Inventory = lazy(() => import("./Components/pages/inventory/Inventory"));
const Category = lazy(() => import("./Components/pages/category/Category"));
const Coupons = lazy(() => import("./Components/pages/coupons/Coupons"));
const Reviews = lazy(() => import("./Components/pages/reviews/Reviews"));
const Banner = lazy(() => import("./Components/pages/banner/Banner"));
const HomeTitle = lazy(() => import("./Components/pages/hometitle/HomeTitle"));
const Explore = lazy(() => import("./Components/pages/explore/Explore"));
const Faq = lazy(() => import("./Components/pages/faq/Faq"));
const SitePolicy = lazy(() => import("./Components/pages/sitePolicy/SitePolicy"));
const SocialMedia = lazy(() => import("./Components/pages/socialMedia/SocialMedia"));
const Shipping = lazy(() => import("./Components/pages/shipping/Shipping"));
const Settings = lazy(() => import("./Components/pages/settings/Settings"));
const Subscribers = lazy(() => import("./Components/pages/settings/Subscribers"));
const RoleList = lazy(() => import("./Components/pages/roleManager/RoleList"));
const Profile = lazy(() => import("./Components/pages/profile/Profile"));

const routes = [
  ["/dashboard", <Dashboard />, ["dashboard"]],
  ["/order-history", <OrderHistory />, ["orders"]],
  ["/order/:id", <OrderDetail />, ["orders", "payments"]],
  ["/payments", <Payments />, ["payments"]],
  ["/user-list", <UserData />, ["customers"]],
  ["/customer/:id", <CustomerDetail />, ["customers"]],
  ["/product", <Product />, ["products"]],
  ["/add-product", <AddProduct />, ["products"]],
  ["/update-product/:id", <UpdateProduct />, ["products"]],
  ["/inventory", <Inventory />, ["products"]],
  ["/category", <Category />, ["categories"]],
  // old separate category pages now live in one screen
  ["/main-category", <Navigate to="/category" replace />, []],
  ["/sub-category", <Navigate to="/category" replace />, []],
  ["/coupons", <Coupons />, ["coupons"]],
  ["/reviews", <Reviews />, ["reviews"]],
  ["/banner", <Banner />, ["content"]],
  ["/home-title", <HomeTitle />, ["content"]],
  ["/home-product/:id", <Navigate to="/home-title" replace />, []],
  ["/explore", <Explore />, ["content"]],
  ["/faq", <Faq />, ["content"]],
  ["/site-policy", <SitePolicy />, ["content"]],
  ["/social-media", <SocialMedia />, ["content"]],
  ["/shipping", <Shipping />, ["settings"]],
  ["/settings", <Settings />, ["settings"]],
  ["/subscribers", <Subscribers />, ["customers", "settings"]],
  ["/role-list", <RoleList />, ["owner"]],
  ["/profile", <Profile />, []],
];

export default function App() {
  return (
    <ConfirmProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          {routes.map(([path, el, perms]) => (
            <Route key={path} path={path} element={<ProtectedRoute component={<Suspense fallback={<div className="empty"><span className="spinner" /></div>}>{el}</Suspense>} perms={perms} />} />
          ))}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar newestOnTop />
    </ConfirmProvider>
  );
}
